import { InjectionToken } from '@angular/core';
import { BaseAddressService } from '../base-classes/base-address.service';

export const ADDRESS_SERVICE = new InjectionToken<BaseAddressService>('ADDRESS_SERVICE');
